import React from "react";
import DetailIconWrapper from "@/components/controls/Task/DetailIconWrapper";
import IconContainer from "@/components/ui/icon-container";
import { FlagPriority } from "@dreamhub/designsystem/icons";

const HighPriorityIndicator: React.FC<{
  tooltip: string;
  className?: string;
}> = ({ tooltip, className }) => {
  return (
    <DetailIconWrapper tooltip={tooltip} className={className}>
      <IconContainer size="5" color="error">
        <FlagPriority />
      </IconContainer>
    </DetailIconWrapper>
  );
};

export default HighPriorityIndicator;
